getDOMLocation